import EmployeeService from './EmployeeService';

export default {
	'services.onboardingEmployeeService': {
		class: EmployeeService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
